import Vue from "vue";

export async function uploadFile({ upload_file, parentId, parentType, upload_file_type }) {
    const vm = Vue;

    const formData = new FormData();
    formData.append("parent_id", parentId);
    formData.append("parent_type", parentType);
    formData.append("file", upload_file);
    formData.append("file_type", upload_file_type);
    formData.append("name", upload_file.name);
    formData.append("who_uploaded", null);
    formData.append(
        "content_type",
        upload_file.type || "application/octet-binary"
    );
    formData.append("file_size", upload_file.size);
    formData.append("recent", true);

    var complete = false;

    var timeout_handle = setTimeout(function () {
        if (!complete) {
            console.log({
                parentType: parentType,
                parentId: parentId,
                file_name: upload_file.name,
                file_size: upload_file.size,
                file_type: upload_file.type,
            });
            Sentry.captureException(new Error("File Upload taking too long"));
        }
    }, 10 * 1000); // 10 Seconds

    var url = `${process.env.VUE_APP_ROOT_API}/api/files/`;
    try {
        const result = await Vue.axios.post(url, formData);
        if (result.status === 201) {
            complete = true;
            clearTimeout(timeout_handle);

            var items =
            {
                id: result.data.id,
                pk: result.data.id,
                _is_deleted: false,
                _display_order: 0,
                details: result.data,
            };

            return items;
        }
    } catch (error) {
        complete = true;
        clearTimeout(timeout_handle);
        console.log(error);
    }

    // .then(
    //   function (response, status, headers) {
    //     complete = true;
    //     clearTimeout(timeout_handle);

    //     var items = [
    //       ...(vm.items || []),
    //       {
    //         id: response.data.id,
    //         pk: response.data.id,
    //         _is_deleted: false,
    //         _display_order: 0,
    //         details: response.data,
    //       },
    //     ];

    //     vm.$refs["uploadImage"].reset();
    //     vm.upload_file_type = null;
    //     return items;
    //   },
    //   function (error) {
    //     complete = true;
    //     clearTimeout(timeout_handle);
    //     console.log(error);
    //   }
    // );


};